import decode from 'jwt-decode'
import { handleErrors } from './Utils'
import { apiUrl } from '../variables/index'
import { attempt, get, isEmpty } from 'lodash'
import publicIp from 'public-ip'

export default class Authentication {
  constructor() {
    this.login = this.login.bind(this)
    this.logout = this.logout.bind(this)
    this.getProfile = this.getProfile.bind(this)
    this.isMaster = this.isMaster.bind(this)
    this.authFetch = this.authFetch.bind(this)
    this.getUserPermissions = this.getUserPermissions.bind(this)
    this.getOrgPermissions = this.getOrgPermissions.bind(this)
    this.getUserServices = this.getUserServices.bind(this)
    this.getOrgServices = this.getOrgServices.bind(this)
    this.checkStatus = this.checkStatus.bind(this)
  }

  login() {}

  getUserServices() {
    return this.getUserPermissions()['services']
  }

  getOrgServices() {
    return this.getOrgPermissions()['services']
  }

  setSession(authResult) {
    console.log({ authResult })
    return new Promise((resolve, reject) => {
      if (authResult && authResult.token) {
        let expiresAt = JSON.stringify(decode(authResult.token)['exp'] * 1000)
        localStorage.setItem('access_token', authResult.token)
        localStorage.setItem('loginIp', authResult.loginIp)
        localStorage.setItem('expires_at', expiresAt)

        sessionStorage.clear()
      }
      resolve()
    })
  }

  getAccessToken() {
    const accessToken = localStorage.getItem('access_token')
    if (!accessToken) {
      console.error('No access token found')
    }
    return accessToken
  }

  setMember(member) {
    localStorage.setItem('member', JSON.stringify(member))
  }

  getMember() {
    const member = localStorage.getItem('member')
    if (!member) {
      console.error('No access token found')
    }
    return JSON.parse(member) || {}
  }

  getProfile() {
    let accessToken = this.getAccessToken()
    return get(decode(accessToken), 'payload')
  }

  logout() {
    console.log('logout')
    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('loginIp')
    localStorage.removeItem('expires_at')
    localStorage.clear()
    sessionStorage.removeItem('organisations_corporates/_dropdown')
    sessionStorage.clear()
    this.userProfile = null

    window.location.reload()
  }

  isAuthenticated() {
    let expiresAt = attempt(() => JSON.parse(localStorage.getItem('expires_at')))

    // let loginIp = localStorage.getItem('loginIp')

    // let currentIp = await publicIp.v4()

    // console.log(loginIp, isEmpty(loginIp), loginIp !== currentIp, currentIp)
    // if (isEmpty(loginIp) || loginIp !== currentIp) {
    //   console.log('logout')
    //   this.logout()
    // }

    return new Date().getTime() < expiresAt
  }

  getRole() {
    const namespace = 'https://example.com'
    const idToken = localStorage.getItem('id_token')
    return decode(idToken)[`${namespace}/role`] || null
  }

  getUserPermissions() {
    const idToken = localStorage.getItem('id_token')
    return decode(idToken).permissions || { services: {} }
  }

  getRequestedUserPermissions() {
    const idToken = localStorage.getItem('id_token')
    return decode(idToken).requestedPermissions || { services: {} }
  }

  getOrgPermissions() {
    const idToken = localStorage.getItem('id_token')
    return decode(idToken).orgPermissions || { services: {} }
  }

  isMaster() {
    const idToken = localStorage.getItem('id_token')
    return decode(idToken).master || false
  }

  authFetch(url, options) {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }

    if (this.isAuthenticated()) {
      headers['Authorization'] = 'Bearer ' + this.getAccessToken()
    }

    return fetch(url, { headers, ...options })
      .then(this.checkStatus)
      .then((response) => response.json())
  }

  checkToken() {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }

    if (this.isAuthenticated()) {
      headers['Authorization'] = 'token ' + this.getAccessToken()
    }
    return fetch(apiUrl + '/profiles/organisation/', { headers }).then(handleErrors)
  }

  checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response
    } else {
      let error = new Error(response.statusText)
      error.response = response
      throw error
    }
  }
}
